document.addEventListener('DOMContentLoaded', () => {
    const banner = document.querySelector('.mm-promo-banner__inner');
    const button = banner.querySelector('.mm-promo-banner__btn');
  
    banner.addEventListener('click', (e) => {
      
      if (e.target === button || button.contains(e.target)) return;
      const url = banner.dataset.url;
      if (url) window.location.href = url;
    });
    banner.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        const url = banner.dataset.url;
        if (url) window.location.href = url;
      }
    });
  });